import { bl_fi_entity_sales_credit_limits_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class EntitySalesCreditLimitsImportFileContainerModel extends BaseContainerModel {
    bl_fi_entity_sales_credit_limits_import_file_hdr: bl_fi_entity_sales_credit_limits_import_file_hdr_RowClass = new bl_fi_entity_sales_credit_limits_import_file_hdr_RowClass();
}